import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { catchError, firstValueFrom, Observable, of } from 'rxjs';
import { Permission } from '../../core/services/models/user';
import { RestApiService } from '../../core/services/rest-api-service';

export const ownerGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const router = inject(Router);
  const translateService = inject(TranslateService);
  const permissionPromise = firstValueFrom(
    inject(RestApiService)
      .getMe()
      .pipe(
        catchError(_err => {
          return of(null);
        })
      )
  ).then(me => {
    if (!me)
      return router.createUrlTree(['/', translateService.currentLang, 'login']);
    else if (me.type === Permission.OWNER) return true;
    else
      return router.createUrlTree(['/', translateService.currentLang, 'home']);
  });
  return permissionPromise;
};
